import React from "react";
import {useRoutes} from "react-router-dom";
import routes from "./routes";
import ScrollToTop from "./components/scrollComponents/ScrollToTop";
import {LoadingBarProvider} from "./context/LoadingBarContext"; // Import Context
import {DataProvider} from './context/DataContext';
import { ToastContainer, Bounce} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    const router = useRoutes(routes); // مدیریت روت‌ها

    return (
        <DataProvider>
            <LoadingBarProvider> {/* پروایدر */}
                <ScrollToTop/>
                {router} {/* نمایش صفحات */}
                <ToastContainer
                    position="top-right"
                    autoClose={3500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    rtl={true}
                    transition={Bounce}
                />
            </LoadingBarProvider>
        </DataProvider>
    );
}

export default App;
